import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Changes the `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#taxmode"
        }}>{`TaxMode`}</a>{` of a cart. When a tax mode is changed from `}<inlineCode parentName="p">{`External`}</inlineCode>{` to `}<inlineCode parentName="p">{`Platform`}</inlineCode>{` or `}<inlineCode parentName="p">{`Disabled`}</inlineCode>{`,
all previously set external tax rates will be removed. When changing the tax mode to `}<inlineCode parentName="p">{`Platform`}</inlineCode>{`, line items,
custom line items and shipping method require a tax category with a tax rate for the given shipping address.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"changeTaxMode"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`taxMode`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#taxmode"
          }}>{`TaxMode`}</a></li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      